import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/i18n";

Vue.use(VueRouter);

// 路由懒加载
const AdminTpl = () => import("@/layouts/AdminTpl.vue");
const HomePage = () => import("@/views/admin/HomePage.vue"); //首页
const RegisterPage = () => import("@/views/login/register.vue"); //登录页
const SignupPage = () => import("@/views/login/signup.vue"); //注册页
const ForgetPage = () => import("@/views/login/forget.vue"); //忘记密码页

const routes = [
  {
    path: "/register",
    name: "Register",
    component: RegisterPage,
    meta: {
      title: "登录",
      requiresAuth: false,
      transition: "fade",
    },
  },
  {
    path: "/signup",
    name: "Signup",
    component: SignupPage,
    meta: {
      title: "注册",
      requiresAuth: false,
      transition: "fade",
    },
  },
  {
    path: "/forget",
    name: "Forget",
    component: ForgetPage,
    meta: {
      title: "忘记密码",
      requiresAuth: false,
      transition: "fade",
    },
  },
  {
    path: "/",
    component: AdminTpl,
    children: [
      {
        path: "",
        name: "HomePage",
        component: HomePage,
        meta: {
          title: "首页",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "car/:id?",
        name: "CarDetail",
        component: () => import("@/views/home/CarDetail.vue"),
        meta: {
          title: "车型详情",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "reserve/:id?",
        name: "CarReserve",
        component: () => import("@/views/home/Reserve.vue"),
        meta: {
          title: "预定配置",
          requiresAuth: false,
          transition: "fade",
          hideFooter: true,
          lockPage: true,
        },
      },
      {
        path: "reserve-order/:id?",
        name: "CarReserveOrder",
        component: () => import("@/views/home/ReserveOrder.vue"),
        meta: {
          title: "填写预订信息",
          requiresAuth: false,
          transition: "fade",
          hideFooter: true,
        },
      },
      {
        path: "technology",
        name: "TechnologyDetail",
        component: () => import("@/views/home/Technology.vue"),
        meta: {
          title: "技术详情",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "about",
        name: "AboutUs",
        component: () => import("@/views/home/About.vue"),
        meta: {
          title: "关于我们",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "about/news",
        name: "AboutNews",
        component: () => import("@/views/about/NewsList.vue"),
        meta: {
          title: "东风快讯",
          requiresAuth: false,
          transition: "fade",
          disableTransition: true,
        },
      },
      {
        path: "about/news/:id",
        name: "NewsDetail",
        component: () => import("@/views/home/NewsDetail.vue"),
        meta: {
          title: "资讯详情",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "testdrive",
        name: "TestDrive",
        component: () => import("@/views/home/TestDrive.vue"),
        meta: {
          title: "预约试驾",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "retail",
        name: "RetailCenter",
        component: () => import("@/views/admin/RetailCenter.vue"),
        meta: {
          title: "零售中心",
          requiresAuth: false,
          transition: "fade",
          hideFooterOnMobile: true,
          lockPageOnMobile: true,
        },
      },
      {
        path: "service",
        name: "ServiceCenter",
        component: () => import("@/views/admin/ServiceCenter.vue"),
        meta: {
          title: "服务中心",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "about/contact",
        name: "ContactUs",
        component: () => import("@/views/home/Contact.vue"),
        meta: {
          title: "联系我们",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "tools/compare",
        name: "CarCompare",
        component: () => import("@/views/home/CarCompare.vue"),
        meta: {
          title: "车型参数对比",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "tools/finance",
        name: "FinanceCalc",
        component: () => import("@/views/home/FinanceCalc.vue"),
        meta: {
          title: "金融试算器",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "tools",
        redirect: "/tools/finance",
      },
      {
        path: "userCenter",
        name: "UserCenter",
        component: () => import("@/views/my/Profile.vue"),
        meta: {
          title: "个人信息",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "my/bookings",
        name: "MyBookings",
        component: () => import("@/views/my/MyBookings.vue"),
        meta: {
          title: "我的预订",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "my/testdrives",
        name: "MyTestDrives",
        component: () => import("@/views/my/MyTestDrives.vue"),
        meta: {
          title: "我的预约试驾",
          requiresAuth: false,
          transition: "fade",
        },
      },
      {
        path: "my/bookings/:id",
        name: "BookingDetail",
        component: () => import("@/views/my/BookingDetail.vue"),
        meta: {
          title: "预订详情",
          requiresAuth: false,
          transition: "fade",
          hideFooter: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  // 使用 Hash 路由，静态服务器无需配置路由回退规则，刷新子页面不会出现 404。
  mode: "hash",
  // 生产环境部署在 /car/ 子目录，使 /car/ 映射至应用入口。
  base: process.env.NODE_ENV === "production" ? "/car/" : "/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 浏览器前进/后退时恢复原滚动位置
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      // 锚点滚动
      return {
        selector: to.hash,
        offset: { x: 0, y: 80 },
      };
    }

    // 等待异步路由组件挂载完成后再定位，避免旧页面底部位置残留。
    // 不使用平滑滚动，防止页面动效初始化期间覆盖本次路由的滚动结果。
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => resolve({ x: 0, y: 0 }));
      });
    });
  },
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 统一设置浏览器页签标题
  document.title = i18n.t("页面标题");

  // 更新meta描述
  if (to.meta.description) {
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", to.meta.description);
  }

  // 更新meta关键词
  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.setAttribute("name", "keywords");
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", to.meta.keywords);
  }

  // 进入/离开登录、注册、忘记密码页时跳过整页闪白动画
  const authNames = ["Register", "Signup", "Forget"];
  const isAuthRoute = authNames.includes(to.name) || authNames.includes(from.name);
  to.meta.disableTransition = isAuthRoute;
  if (!isAuthRoute) {
    const app = document.querySelector("#app");
    if (app) {
      app.classList.add("page-transition");
      setTimeout(() => {
        app.classList.remove("page-transition");
      }, 300);
    }
  }

  // 简单的权限检查示例
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 这里可以添加实际的权限检查逻辑
    const isAuthenticated = localStorage.getItem("token");
    if (!isAuthenticated) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

// 路由后置钩子
router.afterEach(() => { });

export default router;
